// Campos de cadastro dos itens que NÃO são PDV: mobília, equipamento, cozinha,
// tecnologia, caixa, ambiente e auxiliares. Quais campos aparecem depende do
// tipo escolhido.
import React from "react";
import * as AlfredoStyles from "../../../../styles/components/configuration/modals/ItemModal";
import { ITEM_TYPES } from "./catalogoDeItens";

export const CamposDeItemSimples: React.FC<{
  localFormData: any;
  handleLocalChange: (field: string, value: any) => void;
}> = ({ localFormData, handleLocalChange }) => {
  const currentItemType = ITEM_TYPES.find(
    (t) => t.id === localFormData.itemType
  );

  return (
    <AlfredoStyles.ItemBottom style={{ height: "calc(var(--u) * 400)" }}>
      <AlfredoStyles.ItemInfoContainer style={{ height: "100%" }}>
        <AlfredoStyles.ItemInfoFields
          style={{ width: "100%", height: "100%", overflow: "auto" }}
        >
          <AlfredoStyles.FieldsContainer>
            <AlfredoStyles.SectionTitle>
              Configurações do {currentItemType?.name}
            </AlfredoStyles.SectionTitle>

            <AlfredoStyles.FormGrid>
              <AlfredoStyles.InputWrapper>
                <label>Identificação/Modelo *</label>
                <AlfredoStyles.Input
                  type="text"
                  value={localFormData.deviceModel}
                  onChange={(e) =>
                    handleLocalChange("deviceModel", e.target.value)
                  }
                  placeholder={
                    currentItemType?.category === "mobilia"
                      ? `Número ou identificação da ${currentItemType?.name.toLowerCase()}`
                      : currentItemType?.category === "equipamento"
                      ? `Modelo do ${currentItemType?.name.toLowerCase()}`
                      : currentItemType?.category === "cozinha"
                      ? `Modelo do equipamento`
                      : currentItemType?.category === "tecnologia"
                      ? `Modelo do dispositivo`
                      : currentItemType?.category === "caixa"
                      ? `Número ou identificação`
                      : currentItemType?.category === "ambiente"
                      ? `Identificação do equipamento`
                      : currentItemType?.category === "auxiliar"
                      ? `Identificação do item`
                      : `Identificação do item`
                  }
                />
              </AlfredoStyles.InputWrapper>

              <AlfredoStyles.InputWrapper>
                <label>Status</label>
                <AlfredoStyles.Select
                  value={localFormData.status}
                  onChange={(e) =>
                    handleLocalChange("status", e.target.value)
                  }
                >
                  <option value="active">Ativo</option>
                  <option value="inactive">Inativo</option>
                  <option value="maintenance">Manutenção</option>
                </AlfredoStyles.Select>
              </AlfredoStyles.InputWrapper>

              {currentItemType?.category === "mobilia" && (
                <>
                  {[5, 6].includes(localFormData.itemType) && (
                    <AlfredoStyles.InputWrapper>
                      <label>Número/Identificação</label>
                      <AlfredoStyles.Input
                        type="text"
                        value={localFormData.tableNumber}
                        onChange={(e) =>
                          handleLocalChange("tableNumber", e.target.value)
                        }
                        placeholder="Número ou identificação"
                      />
                    </AlfredoStyles.InputWrapper>
                  )}

                  <AlfredoStyles.InputWrapper>
                    <label>Capacidade</label>
                    <AlfredoStyles.Input
                      type="number"
                      value={localFormData.capacity}
                      onChange={(e) =>
                        handleLocalChange(
                          "capacity",
                          parseInt(e.target.value)
                        )
                      }
                      placeholder={
                        [5, 6].includes(localFormData.itemType)
                          ? "Capacidade em pessoas"
                          : localFormData.itemType === 7
                          ? "Capacidade (pessoas)"
                          : "Capacidade"
                      }
                    />
                  </AlfredoStyles.InputWrapper>
                </>
              )}

              {[11, 12, 13, 14, 15, 16, 26, 27, 28].includes(
                localFormData.itemType
              ) && (
                <>
                  <AlfredoStyles.InputWrapper>
                    <label>Endereço IP</label>
                    <AlfredoStyles.Input
                      type="text"
                      value={localFormData.ipAddress}
                      onChange={(e) =>
                        handleLocalChange("ipAddress", e.target.value)
                      }
                      placeholder="192.168.1.100"
                    />
                  </AlfredoStyles.InputWrapper>

                  <AlfredoStyles.InputWrapper>
                    <label>Endereço MAC</label>
                    <AlfredoStyles.Input
                      type="text"
                      value={localFormData.macAddress}
                      onChange={(e) =>
                        handleLocalChange("macAddress", e.target.value)
                      }
                      placeholder="00:1B:44:11:3A:B7"
                    />
                  </AlfredoStyles.InputWrapper>

                  <AlfredoStyles.InputWrapper>
                    <label>Tipo de Conexão</label>
                    <AlfredoStyles.Select
                      value={localFormData.connectionType}
                      onChange={(e) =>
                        handleLocalChange("connectionType", e.target.value)
                      }
                    >
                      <option value="usb">USB</option>
                      <option value="network">Rede</option>
                      <option value="bluetooth">Bluetooth</option>
                    </AlfredoStyles.Select>
                  </AlfredoStyles.InputWrapper>
                </>
              )}

              {[11, 12, 13].includes(localFormData.itemType) && (
                <AlfredoStyles.InputWrapper>
                  <label>Porta</label>
                  <AlfredoStyles.Input
                    type="text"
                    value={localFormData.port}
                    onChange={(e) =>
                      handleLocalChange("port", e.target.value)
                    }
                    placeholder="9100"
                  />
                </AlfredoStyles.InputWrapper>
              )}

              {localFormData.itemType === 23 && (
                <>
                  <AlfredoStyles.InputWrapper>
                    <label>Orientação</label>
                    <AlfredoStyles.Select
                      value={localFormData.tabletOrientation}
                      onChange={(e) =>
                        handleLocalChange("tabletOrientation", e.target.value)
                      }
                    >
                      <option value="landscape">Paisagem</option>
                      <option value="portrait">Retrato</option>
                    </AlfredoStyles.Select>
                  </AlfredoStyles.InputWrapper>

                  <AlfredoStyles.InputWrapper>
                    <label>Tamanho da Tela</label>
                    <AlfredoStyles.Select
                      value={localFormData.displaySize}
                      onChange={(e) =>
                        handleLocalChange("displaySize", e.target.value)
                      }
                    >
                      <option value="small">Pequeno (7")</option>
                      <option value="medium">Médio (10")</option>
                      <option value="large">Grande (12")</option>
                    </AlfredoStyles.Select>
                  </AlfredoStyles.InputWrapper>
                </>
              )}

              <AlfredoStyles.InputWrapper>
                <label>Observações</label>
                <AlfredoStyles.TextArea fullWidth>
                  <textarea
                    value={localFormData.itemDescription}
                    onChange={(e) =>
                      handleLocalChange("itemDescription", e.target.value)
                    }
                    placeholder={`Observações sobre ${currentItemType?.name.toLowerCase()}...`}
                    rows={3}
                  />
                  <label>Descrição Detalhada</label>
                </AlfredoStyles.TextArea>
              </AlfredoStyles.InputWrapper>
            </AlfredoStyles.FormGrid>

            <AlfredoStyles.AlertMessage type="info">
              <span className="material-icons">info</span>
              <div>
                <strong>Dica:</strong> {currentItemType?.description}. Este
                item será cadastrado no sistema e poderá ser associado a
                ambientes e operações específicas da sua loja.
              </div>
            </AlfredoStyles.AlertMessage>
          </AlfredoStyles.FieldsContainer>
        </AlfredoStyles.ItemInfoFields>
      </AlfredoStyles.ItemInfoContainer>
    </AlfredoStyles.ItemBottom>
  );
};
